// import React from 'react';

// export const AuthButton = ({
//   children,
//   onClick,
//   type = 'button',
//   className = '',
//   disabled = false
// }) => {
//   return (
//     <button
//       type={type}
//       onClick={onClick}
//       disabled={disabled}
//       className={`font-roboto bg-cyan-400 hover:bg-cyan-300 text-slate-900 px-12 sm:px-16 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg uppercase tracking-wide transition-all shadow-lg hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 ${className}`}
//     >
//       {children}
//     </button>
//   );
// };

// export default AuthButton;


import React from 'react';

export const AuthButton = ({
  children,
  onClick,
  type = 'button',
  className = '',
  disabled = false
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-500
        hover:from-cyan-400 hover:via-blue-300 hover:to-cyan-500
        text-slate-900
        px-12 sm:px-16 py-4 sm:py-5
        rounded-[1rem]
        font-bold text-base sm:text-lg uppercase tracking-wide
        border-2 border-white
        shadow-lg shadow-cyan-500/50
        transition-all duration-300
       
        disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default AuthButton;
